module.exports = {"530323001":"丹凤街道","530323002":"漾月街道","530323003":"大同街道","530323102":"雄壁镇","530323103":"葵山镇","530323104":"彩云镇","530323105":"竹基镇","530323202":"龙庆彝族壮族乡","530323203":"五龙壮族乡","530323204":"高良壮族苗族瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530323.json
// module id = 2692
// module chunks = 0